<div class="container-fuild d-flex flex-column" style="overflow-y: auto; flex-grow: 1; flex-basis:0; height: 100%;">
    <div class="d-flex flex-row">
        <ng-content select="[utility]"></ng-content>
    </div>
    <table class="table">
        <thead>
            <tr>
                <th *ngIf="showCheckBoxes"><input type="checkbox" [checked]="allChecked" (click)="selectAllItems()"></th>
                <ng-container *ngFor="let name of columnNames; index as i">
                  <th *ngIf="!ignoreColumns.includes(name)">
                    <div class="d-flex flex-row align-items-center justify-content-between">
                        <div>{{name}}</div>
                        <div *ngIf="showSorting">
                            <button
                                [ngClass]="sortProperty==objectKeys[i] && sortType==2 ? 'btn btn-sm text-primary' : 'btn btn-sm text-muted'"
                                (click)="sortAscending(i)">
                                <i class="fa fa-arrow-down"></i>
                            </button>
                            <button
                                [ngClass]="(sortProperty==objectKeys[i] && sortType==1) ? 'btn btn-sm text-primary' : 'btn btn-sm text-muted'"
                                (click)="sortDescending(i)">
                                <i class="fa fa-arrow-up"></i>
                            </button>
                        </div>
                    </div>
                  </th>
                </ng-container>

                <th *ngIf="actions.length>0">Actions</th>
            </tr>
        </thead>
        <tbody class="">
            <tr *ngFor="let item of listOfItems; index as rowIndex">
                <td *ngIf="showCheckBoxes"><input type="checkbox" [checked]="selectedItems.includes(item)" (click)="setSelectedItem(item)"></td>
                <ng-container *ngFor="let key of objectKeys; index as i">
                  <td *ngIf="ignoreColumn(key)">
                    <span *ngIf="!columnDataOverridden[i]">
                      {{item[key]}}
                    </span>
                    <div *ngIf="columnDataOverridden[i]">
                      <div [innerHTML]="overriddenData[rowIndex][i]"></div>
                    </div>
                  </td>
                </ng-container>
                <td *ngIf="actions.length > 0" >
                    <div class="d-flex">
                        <div *ngFor="let action of actions; index as i" class="d-flex flex-row">
                            <button [ngClass]="'btn btn-sm btn-'+action.color" (click)="action.callback(item)">{{action.displayName}}</button>
                            <div class="mx-1 border" *ngIf="i != actions.length-1"></div>
                        </div>
                    </div>
                </td>
            </tr>
        </tbody>

    </table>
    <div *ngIf="showPagination" class="d-flex flex-row justify-content-between px-3">
        <div>{{currentItems}} of {{totalItems}}</div>
        <div class="d-flex flex-row">
            <button class="btn btn-sm btn-link me-1" [disabled]="currentPage == 1" (click)="goToPrevious()"><i class="fa fa-arrow-left"></i></button>
            <button
                [ngClass]="currentPage == 1 ? 'btn btn-sm btn-primary mx-1' : 'btn btn-sm btn-outline-primary mx-1'"
                (click)="goToPage(1)">
                1
            </button>
            <div *ngIf="currentPage > 3 && numOfPages > 5">...</div>
            <button
                *ngFor="let pageNumber of listOfPages"
                [ngClass]="currentPage == pageNumber ? 'btn btn-sm btn-primary mx-1' : 'btn btn-sm btn-outline-primary mx-1'"
                (click)="goToPage(pageNumber)">
                {{pageNumber}}
            </button>
            <div *ngIf="currentPage != numOfPages && currentPage < (numOfPages - 2)">...</div>
            <button
                *ngIf="numOfPages != 1"
                [ngClass]="currentPage == numOfPages ? 'btn btn-sm btn-primary mx-1' : 'btn btn-sm btn-outline-primary mx-1'"
                (click)="goToPage(numOfPages)">
                {{numOfPages}}
            </button>
            <button class="btn btn-sm btn-link" [disabled]="currentPage==numOfPages" (click)="goToNext()"><i class="fa fa-arrow-right"></i></button>
        </div>
    </div>
</div>
